import * as React from 'react';
import { useNavigate } from "react-router";

import { NoteCard } from "./NoteCard";
import { NoteComments } from "./NoteComments";
import { PDFNote } from '../models/PDFNote';
import { services } from '../../../services';
import { useBackgroundPromiseWrapper } from '../../../helpers/hooks/useBackgroundPromiseWrapper';
import { ProjectDoc } from '../../projectDocs/models/ProjectDoc';

interface NoteFormProps {
  id: number;
  projectDoc?: ProjectDoc;
  onNoteChanged: (note: PDFNote) => void;
}

export const NoteForm: React.FC<NoteFormProps> = ({ id, projectDoc, onNoteChanged }) => {
  
  const [pdfNote, setPdfNote] = React.useState<PDFNote>();
  const changePdfNote = React.useCallback((note: PDFNote) => {
    setPdfNote(note);
    onNoteChanged(note);
  }, [onNoteChanged]);

  const [promiseWrapper] = useBackgroundPromiseWrapper();
  const navigate = useNavigate();

  const loadNote = React.useCallback(() => {
    if (id === 0)
      return;

    promiseWrapper(
      () => services.pDFNoteService.getById(id),
      (res: PDFNote) => changePdfNote(res)
    );
    // eslint-disable-next-line
  }, [id, changePdfNote]);
  // eslint-disable-next-line
  React.useEffect(loadNote, [id]);

  const updateNoteWithoutRealod = React.useCallback((note: PDFNote, isDeleted: boolean) => {
    if (isDeleted) {
      navigate(`/notes`);
      return;
    }

    changePdfNote(note);
    // eslint-disable-next-line
  }, [changePdfNote]);

  const onCommentsChanged = (count: number) => {
    if (pdfNote)
      changePdfNote({ ...pdfNote, CommentsCount: count });
  }


  return (
    <div className="note-view-body">
      {pdfNote && (
        <NoteCard
          pdfNote={pdfNote}
          projectDocFolderStatusId={0}
          projectDoc={projectDoc}
          onNoteChanged={() => {}}
          defaultExpanded />
      )}
      <NoteComments noteId={pdfNote?.Id ?? 0} onCommentsChanged={onCommentsChanged} />
    </div>
  );
}
